import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect,
} from "react-router-dom";
import Login from "../Components/auth/Login";
import Register from "../Components/auth/Register";
import Subscribers from "../Components/main/Subscribers";
import ChangePassword from "../Components/main/ChangePassword";
import Earning from "../Components/main/Earning";
import EditProfile from "../Components/main/EditProfile";
import Notification from "../Components/main/Notification";
import OrderView from "../Components/main/OrderView";
import PaymentSettting from "../Components/main/PaymentSettting";
import Paypal from "../Components/main/Paypal";
import Profile from "../Components/main/Profile";
import Requests from "../Components/main/Requests";
import RequestView from "../Components/main/RequestView";
import Stripe from "../Components/main/Stripe";
import SubscriptionSettings from "../Components/main/SubscriptionSettings";
import PrivateRoute from "./Privateroute";
import Lessions from "../Components/main/courses/Lessions/Lessions";
import EditLession from "../Components/main/courses/Lessions/EditLession";
import AddLession from "../Components/main/courses/Lessions/AddLession";
import ViewLession from "../Components/main/courses/Lessions/ViewLession";
import Subjects from "../Components/main/courses/Subjects/Subjects";
import Addsubject from "../Components/main/courses/Subjects/Addsubject";
import Editsubject from "../Components/main/courses/Subjects/Editsubject";
import Subjectbanner from "../Components/main/courses/Subjects/Subjectbanner";
import Languages from "../Components/main/courses/Language/Languages";
import AddLanguage from "../Components/main/courses/Language/Addlanguage";
import EditLanguage from "../Components/main/courses/Language/EditLanguage";
import Dashboard from "../Components/main/Dashboard";
import Base from "../Components/Base";
import PublicProfile from "../Components/main/PublicProfile";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { isAutheticated } from "../Components/auth/authhelper";
import { API } from "../API";
import Home from "../Components/customer/Home";
import Subscription from "../Components/customer/Subscription";
import UserPaypal from "../Components/customer/UserPaypal";
import PaymentDetails from "../Components/customer/PaymentDetails";
import StripePayment from "../Components/customer/StripePayment";
import PaymentGate from "../Components/customer/PaymentGate";
import FakePath from "../Components/FakePath";
import Products from "../Components/main/Commerce/Products/Products";
import FeacheredProducts from "../Components/main/Commerce/Products/FeatureProduct/FeaturedProducts";
import AddFeacheredProducts from "../Components/main/Commerce/Products/FeatureProduct/AddFeatureProduct";
import EditFeacheredProducts from "../Components/main/Commerce/Products/FeatureProduct/EditFeatureProduct";
import AddProducts from "../Components/main/Commerce/Products/AddProducts";
import Editproducts from "../Components/main/Commerce/Products/Editproducts";
import Catagory from "../Components/main/Commerce/Catagory/Catagory";
import AddCatagory from "../Components/main/Commerce/Catagory/AddCatagory";
import EditCatagory from "../Components/main/Commerce/Catagory/EditCatagory";
import TVShowSeason from "../Components/main/courses/Language/TVShowSeason";
import TVShowSeasonEpisode from "../Components/main/courses/Language/TVShowSeasonEpisode";
import ViewSeason from "../Components/main/courses/Language/ViewSeason";
import AddSeason from "../Components/main/courses/Language/AddSeason";
import AddEpisode from "../Components/main/courses/Language/AddEpisode";
import EditSeason from "../Components/main/courses/Language/EditSeason";
import AddStudio from "../Components/main/courses/Studio/addStudio";
import SubscriberHistory from "../Components/main/SubscriberHistory";
import AddVideoCatagory from "../Components/main/courses/categories/addCategory";
import EditVideoCatagory from "../Components/main/courses/categories/EditCategory";
import VideoCatagory from "../Components/main/courses/categories/viewCategory";
import scheduleVideos from "../Components/main/courses/schedule/scheduleVideos";
import AddScheduleVideo from "../Components/main/courses/schedule/addScheduleVideo";
import EditScheduleVideo from "../Components/main/courses/schedule/editSchedualVideo";
import AllCoupons from "../Components/main/courses/coupons/coupons";
import AddCoupon from "../Components/main/courses/coupons/addCoupon";
import EditCoupon from "../Components/main/courses/coupons/editCoupon";
import AllShippings from "../Components/main/courses/shipping/shippings";
import AddShipping from "../Components/main/courses/shipping/addShipping";
import EditShipping from "../Components/main/courses/shipping/editShipping";
import TaxRates from "../Components/main/courses/payments/taxRates";
import AddTaxRate from "../Components/main/courses/payments/addTaxRate";
import EditTaxRate from "../Components/main/courses/payments/editTaxRate";
import ProductView from "../Components/main/Commerce/Products/ViewProduct";
import SetUpPage1 from "../Components/auth/setup pages/SetupPage1";
import SetUpPage2 from "../Components/auth/setup pages/SetupPage2";
import SetUpPage3 from "../Components/auth/setup pages/SetupPage3";

// Configuration
import ConfigProfile from "../Components/main/configurations/Profile";
import ConfigText from "../Components/main/configurations/Text";
import TextAdd from "../Components/main/configurations/TextAdd";
import ConfigTextEdit from "../Components/main/configurations/TextEdit";
import ConfigAddress from "../Components/main/configurations/Address";
import ConfigSocialMedia from "../Components/main/configurations/SocialMedia";
import ConfigLogo from "../Components/main/configurations/Logo";
import ConfigMobileTV from "../Components/main/configurations/MobileTV";

// Orders
import OrdMngOrder from "../Components/main/ordersManagement/Orders";
import OrdMngOrderEdit from "../Components/main/ordersManagement/OrderEdit";

// Email Templates
import EmailTemplate from "../Components/main/emailTemplates/EmailTemplates";
import EmailTemplateEdit from "../Components/main/emailTemplates/EmailTempalteEdit";
import SalesLeads from "../Components/main/ordersManagement/SalesLeads";
import SalesLeadsView from "../Components/main/ordersManagement/SalesLeadsVew";
import AdLessions from "../Components/main/courses/AdVideos/AdLessions";
import EditAdLession from "../Components/main/courses/AdVideos/EditAdLession";
import AddAdLession from "../Components/main/courses/AdVideos/AddAdLession";
import ViewAdLession from "../Components/main/courses/AdVideos/ViewAdLession";
import Staff from "../Components/main/Staff/Staff";
import EditStaff from "../Components/main/Staff/EditStaff";
import AddStaff from "../Components/main/Staff/AddStaff";
import ViewStaff from "../Components/main/Staff/ViewStaff";
import StaffLogin from "../Components/auth/StaffLogin";
import ForgotPassword from "../Components/auth/ForgotPassword";
import StaffForgotPassword from "../Components/auth/ForgotPasswordStaff";
import ReportSubscribers from "../Components/main/Reports/ReportSubscribers";
import ReportEarnings from "../Components/main/Reports/ReportEarnings";
import ReportVideos from "../Components/main/Reports/ReportVideos";
import ShopBanner from "../Components/main/Commerce/ShopBanner/ShopBanner";
//Settings Routes
import SubscriptionTypes from "../Components/main/Settings/SubscriptionTypes.js"
import CurrencySymbol from "../Components/main/Settings/CurrencySymbol.js";
import ApplicationNamePage from "../Components/main/Settings/ApplicationName.js";
import Logo from "../Components/main/Settings/Logo.js";
import TopActivity from "../Components/Analytics/TopActivity.jsx";
import UserActivity from "../Components/Analytics/UserActivity.jsx";
import DeviceAnalytics from "../Components/Analytics/DeviceAnalytics.jsx";
import GeoAnalytics from "../Components/Analytics/GeoAnalytics.jsx";
import Bandwidth_Consumption from "../Components/Analytics/Bandwidth_Consumption.js";
import WatchTimeGraph from "../Components/Analytics/WatchTimeGraph.js";
import NotAllowedPage from "../Components/main/NotAllowedPage.js";
import Billing from "../Components/Billing/Billing.js";
import ViewInvoice from "../Components/Billing/ViewInvoice.js";
import Subscription_Fee from "../Components/Billing/Subscription_Fee.js";
import Help from "../Components/HelpAllSection/Help.js";
import ProductClicks from "../Components/Analytics/ProductClicks.js";
import Channels from "../Components/main/courses/categories/AllChannels/All_Channel.js";
import SoComAdvisor from "../Components/main/SoCom_Advisor/SoComAdvisor.js";
import AddSoComAdvisor from "../Components/main/SoCom_Advisor/AddSoComAdvisor.js";
import EditSoComAdvisor from "../Components/main/SoCom_Advisor/EditSoComAdvisor.js";

// 

export default function Routes() {
  // const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [headerLogo, setHeaderLogo] = useState(false);

  const { token, type } = isAutheticated();
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${API}/api/config/`);
        if (response.data.result[0]?.logo[0]?.Headerlogo) {
          setHeaderLogo(response.data.result[0]?.logo[0]?.Headerlogo);
        }
      } catch (error) {
        console.error("Failed to fetch the Admin logo:", error);
      }
    };
    fetchLogo();
  }, []);

  useEffect(() => {
    if (!token) {
    } else {
      // if (type === "staff") {
      //   axios
      //     .get(`${API}/api/staffuser`,
      //       {
      //         headers: {
      //           Authorization: `Bearer ${token}`,
      //         },
      //       })
      //     .then((response) => {
      //       setLoading(false);
      //       console.log("here the response",response);
      //     })
      //     .catch((err) => {
      //       // localStorage.removeItem("auth");
      //       setLoading(false);
      //       // window.location.reload();
      //     });
      // } else {
      axios
        .get(`${API}/api/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setLoading(false);
          //console.log("here the response",response);
        })
        .catch((err) => {
          localStorage.removeItem("auth");
          setLoading(false);
          window.location.reload();
        });
      // }
    }
  }, [token]);
  //jj
  setInterval(async () => {
    let idToken = sessionStorage.getItem("id_token");
    let refresh_token = sessionStorage.getItem("refresh_token");
    let params = new URLSearchParams({ refresh_token });
    refresh_token &&
      (await axios
        .post(`${API}/api/client/refreshToken`, params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${idToken}`,
          },
        })
        .then((response) => {
          console.log("cognito data", response);
          let data = response.data.data;
          sessionStorage.setItem("access_token", data.AccessToken);
          sessionStorage.setItem("id_token", data.IdToken);
        })
        .catch((err) => {
          console.log(err);
        }));
  }, 3000000);
  return (
    <Router>
      <Switch>
        {/* <Route path='/' exact component={Login}></Route> */}
        <Route
          path="/"
          exact
          render={(props) => <Login {...props} headerLogo={headerLogo} />}
        />
        <Route
          component={ForgotPassword}
          exact
          path='/admin/forgotpassword'></Route>
        <Route
          component={StaffForgotPassword}
          exact
          path='/staff/forgotpassword'></Route>
        {/* <Route path="/stafflogin" element={<StaffLogin headerLogo={headerLogo} />} /> */}
        <Route
          path="/stafflogin"
          exact
          render={(props) => <StaffLogin {...props} headerLogo={headerLogo} />}
        />


        <Route path='/customer' exact component={Home}></Route>
        <Route path='/register' exact component={Register}></Route>
        <Route path='/setup-page-1' exact component={SetUpPage1}></Route>
        <Route path='/setup-page-2' exact component={SetUpPage2}></Route>
        <Route path='/setup-page-3' exact component={SetUpPage3}></Route>
        {/* <Route path="/profile/:username" exact component={PublicProfile}></Route> */}
        <Route
          path='/subscription'
          exact
          component={() => {
            let idToken = sessionStorage.getItem("id_token");
            if (idToken) {
              return <Redirect to='/customer' />;
            } else {
              return <Redirect to='/register/cognito' />;
            }
          }}></Route>
        <Route path='/user/paypal' exact component={UserPaypal}></Route>
        <Route path='/user/stripe' exact component={StripePayment}></Route>
        <Route path='/user/payment' exact component={UserPaypal}></Route>
        <Route path='/paymentDetails' exact component={PaymentDetails}></Route>
        <Route
          path='/public/:username'
          render={(props) => {
            return <PublicProfile {...props} />;
          }}
        />
        <Route
          path='/register/cognito'
          exact
          component={() => {
            window.location.href =
              "https://kourses.auth.ap-south-1.amazoncognito.com/signup?client_id=l0npk96glld2b02at5nidndcq&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://kourse-53d4f.web.app/cognito/callback";
            return null;
          }}
        />
        <Route
          path='/sign/cognito'
          exact
          component={() => {
            window.location.href =
              "https://kourses.auth.ap-south-1.amazoncognito.com/login?client_id=l0npk96glld2b02at5nidndcq&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://kourse-53d4f.web.app/cognito/callback";
            return null;
          }}
        />
        <Route
          path='/cognito/callback'
          exact
          render={(props) => {
            return <FakePath {...props} />;
          }}
        />
        <Route
          path='/fakepath'
          exact
          component={() => {
            return <Redirect to='/customer' />;
          }}
        />
        <Route
          path='/payment/stripe/refresh'
          exact
          component={() => {
            axios
              .get(`${API}/api/user/stripe/onboard-user/refresh`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((response) => {
                const getData = response.data.url;
                console.log("token data", getData);
                window.location.href = getData;
              })
              .catch((err) => {
                console.log(err);
              });
            return null;
          }}
        />

        <Route
          path='/payment/stripe/return'
          exact
          component={() => {
            axios
              .get(`${API}/api/user/stripe/checkAccountStatus`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              })
              .then((response) => {
                const getData = response;
                console.log("token data", getData);
                // history.push("/payment");
                //window.location.href="http://localhost:3000/#/payment";
              })
              .catch((err) => {
                console.log(err);
              });
            return <Redirect to='/payment' />;
          }}
        />
        <Base>
          {/* BASE STARTING HERE */}
          <PrivateRoute
            path='/dashboard'
            exact
            component={Dashboard} requiredPermission="Dashboard"></PrivateRoute>

          {/* Analitics Routes */}

          <PrivateRoute
            path='/top-activity'
            exact
            component={TopActivity} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/user-activity'
            exact
            component={UserActivity} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/device-analytics'
            exact
            component={DeviceAnalytics} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/bandwidth-consumption'
            exact
            component={Bandwidth_Consumption} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/geo-analytics'
            exact
            component={GeoAnalytics} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/watch_time'
            exact
            component={WatchTimeGraph} requiredPermission="Analytics"></PrivateRoute>
          <PrivateRoute
            path='/video_popup_click_transactions'
            exact
            component={ProductClicks} requiredPermission="Analytics"></PrivateRoute>



          {/* {Analitics Routes End} */}

          {/* settings Routes */}
          <Route
            path='/subscription_types'
            exact
            component={SubscriptionTypes} requiredPermission="Setting"></Route>
          {/* analytics
             */}
          <Route
            path='/currency'
            exact
            component={CurrencySymbol} requiredPermission="Setting"></Route>
          <Route
            path='/logo'
            exact
            component={Logo} requiredPermission="Setting"></Route>
          <Route
            path='/business_name'
            exact
            component={ApplicationNamePage} requiredPermission="Setting"></Route>


          {/*  settings Routes End*/}
          <Route
            path='/registration_fees'
            exact
            component={Billing} ></Route>
          <Route
            path='/subscription_fees'
            exact
            component={Subscription_Fee} ></Route>



          <Route
            path='/invoice/:id'
            exact
            component={ViewInvoice} ></Route>
          <Route
            path='/help'
            exact
            component={Help} ></Route>



          <PrivateRoute
            path='/notification'
            exact
            component={Notification}></PrivateRoute>
          <PrivateRoute
            path='/payment'
            exact
            component={PaymentSettting}></PrivateRoute>
          {/* <Route path="/payment" exact component={PaymentSettting}></Route> */}
          <PrivateRoute
            path='/profile'
            exact
            component={Profile}></PrivateRoute>
          <PrivateRoute
            path='/edit/profile'
            exact
            component={EditProfile}></PrivateRoute>
          <PrivateRoute
            path='/change/password'
            exact
            component={ChangePassword}></PrivateRoute>

          <PrivateRoute
            path='/earning'
            exact
            component={Earning}></PrivateRoute>

          <PrivateRoute
            path='/report/subscribers'
            exact
            component={ReportSubscribers}></PrivateRoute>
          <PrivateRoute
            path='/report/earnings'
            exact
            component={ReportEarnings}></PrivateRoute>
          <PrivateRoute
            path='/report/videos'
            exact
            component={ReportVideos}></PrivateRoute>
          {/*<PrivateRoute
            path="/report/watched"
            exact
            component={Earning}
          ></PrivateRoute>
          <PrivateRoute
            path="/report/viewers"
            exact
            component={Earning}
          ></PrivateRoute> */}
          {/* Not Allow Routes  */}
          <Route
            component={NotAllowedPage}
            exact
            path='/not-allowed'></Route>
          {/* Not Allow ROute PAge ENd */}
          <PrivateRoute
            path='/order/view/:id'
            exact
            component={OrderView}></PrivateRoute>
          <PrivateRoute
            path='/subscriber/history/:id'
            exact
            component={SubscriberHistory}></PrivateRoute>
          <PrivateRoute
            path='/subscription/settings'
            exact
            component={SubscriptionSettings}
            requiredPermission="Setting"></PrivateRoute>
          <PrivateRoute
            component={Subscribers}
            exact
            path='/subscribers' requiredPermission="Setting"></PrivateRoute>
          <PrivateRoute
            component={Lessions}
            exact
            path='/videos' requiredPermission="Videos"></PrivateRoute>
          <PrivateRoute
            component={EditLession}
            exact
            path='/video/edit/:lessionId' requiredPermission="Videos"></PrivateRoute>
          <PrivateRoute
            component={AddLession}
            exact
            path='/video/add' requiredPermission="Videos"></PrivateRoute>
          <PrivateRoute
            component={AddStudio}
            exact
            path='/video/add-commerce/:id' requiredPermission="Videos"></PrivateRoute>
          <PrivateRoute
            component={ViewLession}
            exact
            path='/video/view/:lessionId' requiredPermission="Videos"></PrivateRoute>

          <PrivateRoute
            component={AdLessions}
            exact
            path='/ad_video' requiredPermission="Advertisements"></PrivateRoute>
          <PrivateRoute
            component={EditAdLession}
            exact
            path='/ad_video/edit/:adlessionId' requiredPermission="Advertisements"></PrivateRoute>
          <PrivateRoute
            component={AddAdLession}
            exact
            path='/ad_video/add' requiredPermission="Advertisements"></PrivateRoute>
          {/* <PrivateRoute
            component={AddStudio}
            exact
            path="/adlessions/add-studio/:id"
          ></PrivateRoute> */}
          <PrivateRoute
            component={ViewAdLession}
            exact
            path='/ad_video/view/:adlessionId' requiredPermission="Advertisements"></PrivateRoute>

          <PrivateRoute
            component={Subjects}
            exact
            path='/subjects'></PrivateRoute>
          <PrivateRoute
            component={Addsubject}
            exact
            path='/subjects/add'></PrivateRoute>
          <PrivateRoute
            component={Editsubject}
            exact
            path='/subjects/edit/:subjectId'></PrivateRoute>
          <PrivateRoute
            component={Subjectbanner}
            exact
            path='/subjects/banner'></PrivateRoute>

          <PrivateRoute
            component={Languages}
            exact
            path='/alllanguages'></PrivateRoute>
          <PrivateRoute
            component={AddLanguage}
            exact
            path='/languages/add'></PrivateRoute>
          <PrivateRoute
            component={EditLanguage}
            exact
            path='/languages/edit/:languageId'></PrivateRoute>
          <PrivateRoute
            component={TVShowSeason}
            exact
            path='/language/tvshow/:tvshowId'></PrivateRoute>
          <PrivateRoute
            component={AddEpisode}
            exact
            path='/season/episode/add/:seasonIdparams'></PrivateRoute>
          <PrivateRoute
            component={TVShowSeasonEpisode}
            exact
            path='/language/season/view/:seasonIdparams'></PrivateRoute>
          <PrivateRoute
            component={EditSeason}
            exact
            path='/language/season/edit/:seasonIdparams'></PrivateRoute>

          <PrivateRoute
            component={AddSeason}
            exact
            path='/language/season/add/:tvshowId'></PrivateRoute>
          <PrivateRoute
            component={Products}
            exact
            path='/comproducts'></PrivateRoute>
          <PrivateRoute
            component={FeacheredProducts}
            exact
            path='/featured/products'></PrivateRoute>
          <PrivateRoute
            component={AddFeacheredProducts}
            exact
            path='/add/feature/product'></PrivateRoute>
          <PrivateRoute
            component={EditFeacheredProducts}
            exact
            path='/edit/feature/product/:id'></PrivateRoute>
          <PrivateRoute
            component={AddProducts}
            exact
            path='/comproducts/add'></PrivateRoute>
          <PrivateRoute
            component={Editproducts}
            exact
            path='/comproducts/edit/:productId'></PrivateRoute>
          <PrivateRoute
            component={ProductView}
            exact
            path='/comproducts/view/:productId'></PrivateRoute>
          <PrivateRoute
            component={Catagory}
            exact
            path='/comcatagory'></PrivateRoute>
          <PrivateRoute
            component={AddCatagory}
            exact
            path='/comcatagory/add'></PrivateRoute>
          {/* coupons */}
          <PrivateRoute
            component={AllCoupons}
            exact
            path='/allCoupons'></PrivateRoute>

          <PrivateRoute
            component={AddCoupon}
            exact
            path='/coupon_add'></PrivateRoute>
          {/* shop banner */}
          <PrivateRoute
            component={ShopBanner}
            exact
            path='/shop_banner'></PrivateRoute>
          <PrivateRoute
            component={EditCoupon}
            exact
            path='/coupon_edit/:id'></PrivateRoute>
          {/* shipping  */}
          <PrivateRoute
            component={AllShippings}
            exact
            path='/allShippings'></PrivateRoute>

          <PrivateRoute
            component={AddShipping}
            exact
            path='/shipping_add'></PrivateRoute>
          <PrivateRoute
            component={EditShipping}
            exact
            path='/shipping_edit/:id'></PrivateRoute>

          {/* Configurations */}

          <PrivateRoute
            component={ConfigProfile}
            exact
            path='/configuration/profile'></PrivateRoute>
          <PrivateRoute
            component={ConfigText}
            exact
            path='/configuration/text'></PrivateRoute>

          <PrivateRoute
            component={TextAdd}
            exact
            path='/configuration/text/textadd'></PrivateRoute>

          <PrivateRoute
            component={ConfigTextEdit}
            exact
            path='/configuration/text/textedit/:id'></PrivateRoute>
          <PrivateRoute
            component={ConfigAddress}
            exact
            path='/configuration/address'></PrivateRoute>
          <PrivateRoute
            component={ConfigSocialMedia}
            exact
            path='/configuration/social-media'></PrivateRoute>
          <PrivateRoute
            component={ConfigLogo}
            exact
            path='/configuration/logo'></PrivateRoute>
          <PrivateRoute
            component={ConfigMobileTV}
            exact
            path='/configuration/mobile-tv'></PrivateRoute>

          {/* Orders Management */}
          <PrivateRoute
            component={SalesLeads}
            exact
            path='/order/sales-leads'></PrivateRoute>
          <PrivateRoute
            component={SalesLeadsView}
            exact
            path='/order/sales-leads/:id'></PrivateRoute>
          <PrivateRoute
            component={OrdMngOrder}
            exact
            path='/orders/:status'></PrivateRoute>
          <PrivateRoute
            component={OrdMngOrderEdit}
            exact
            path='/orders/:status/:id'></PrivateRoute>

          {/* Email Templates */}
          <PrivateRoute
            component={EmailTemplate}
            exact
            path='/email-templates'></PrivateRoute>
          <PrivateRoute
            component={EmailTemplateEdit}
            exact
            path='/email-templates/:id'></PrivateRoute>

          {/* payments  */}
          <PrivateRoute
            component={TaxRates}
            exact
            path='/tax-rates'></PrivateRoute>
          <PrivateRoute
            component={AddTaxRate}
            exact
            path='/add_taxRate'></PrivateRoute>
          <PrivateRoute
            component={EditTaxRate}
            exact
            path='/edit_taxRate/:id'></PrivateRoute>

          {/* video categories */}

          <PrivateRoute
            component={AddVideoCatagory}
            exact
            path='/network_channel/add' requiredPermission="NetworkChannels"></PrivateRoute>
          <PrivateRoute
            component={VideoCatagory}
            exact
            path='/network_channels' requiredPermission="NetworkChannels"></PrivateRoute>
          <PrivateRoute
            component={EditVideoCatagory}
            exact
            path='/network_channel/edit/:id' requiredPermission="NetworkChannels"></PrivateRoute>

          <PrivateRoute
            component={Channels}
            exact
            path='/channels' requiredPermission="NetworkChannels"></PrivateRoute>







          {/* staff */}
          <PrivateRoute
            component={AddStaff}
            exact
            path='/team/add' requiredPermission="Staff"></PrivateRoute>
          <PrivateRoute component={Staff} exact path='/team' requiredPermission="Staff"></PrivateRoute>
          <PrivateRoute
            component={EditStaff}
            exact
            path='/team/edit/:id' requiredPermission="Staff"></PrivateRoute>
          <PrivateRoute
            component={ViewStaff}
            exact
            path='/team/view/:id' requiredPermission="Staff"></PrivateRoute>
          {/* SoCom_advisor */}
          <PrivateRoute
            component={AddSoComAdvisor}
            exact
            path='/SoCom_advisor/add' requiredPermission="Staff"></PrivateRoute>
          <PrivateRoute
            component={EditSoComAdvisor}
            exact
            path='/SoCom_advisor/edit/:id' requiredPermission="Staff"></PrivateRoute>
          <PrivateRoute component={SoComAdvisor} exact path='/SoCom_advisor' requiredPermission="Staff"></PrivateRoute>


          {/*  */}
          <PrivateRoute
            component={EditCatagory}
            exact
            path='/comcatagory/edit/:catagoryId'></PrivateRoute>
          {/* scheduleVideos */}
          <PrivateRoute
            component={scheduleVideos}
            exact
            path='/scheduleVideos'></PrivateRoute>
          <PrivateRoute
            component={EditScheduleVideo}
            exact
            path='/edit-schedule-video/:typevideo/:id'></PrivateRoute>
          <PrivateRoute
            component={AddScheduleVideo}
            exact
            path='/add-schedule-video'></PrivateRoute>

          {/* BASE ENDING HERE */}
        </Base>
        <PrivateRoute
          path='/payment/paypal'
          exact
          component={Paypal}></PrivateRoute>
        <PrivateRoute
          path='/payment/stripe'
          exact
          component={Stripe}></PrivateRoute>
        <PrivateRoute
          path='/requests'
          exact
          component={Requests}></PrivateRoute>
        <PrivateRoute
          path='/requests/view'
          exact
          component={RequestView}></PrivateRoute>



        {/* <PrivateRoute
          path="/:username"
          exact
          component={PublicProfile}
        ></PrivateRoute> */}


        {/* settings Routes */}


        {/*  */}
      </Switch>
    </Router >
  );
}
